import { Grid, IconButton, InputAdornment, Typography, Divider, Tooltip, Stack, Button } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import { gridSpacing, IMAGE_SIZE } from "../../../../../store/constants";
import TextField from "../../../../../utils/ui-components/FormsUI/TextField";
import { useState } from "react";
import ItemImageUpload from "../../../../../utils/ui-components/FormsUI/ItemImageUpload/item-image-upload.component";
import Select from "../../../../../utils/ui-components/FormsUI/Select";
import SwitchWrapper from "../../../../../utils/ui-components/FormsUI/Switch";
import MainCard from "../../../../../utils/ui-components/MainCard";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { UserAddValues } from ".";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const ACCOUNT_TYPES = [
  {
    value: 1,
    label: "Prepaid",
  },
  {
    value: 2,
    label: "Postpaid",
  },
];

const INDUSTRY_TYPES = [
  {
    value: 1,
    label: "Construction",
  },
  {
    value: 2,
    label: "Retail",
  },
  {
    value: 3,
    label: "Transportation",
  },
  {
    value: 4,
    label: "Financial Service",
  },
  {
    value: 5,
    label: "Agriculture",
  },
  {
    value: 6,
    label: "Education",
  },
  {
    value: 7,
    label: "Technology",
  },
  {
    value: 8,
    label: "Health Care",
  },
];

function UserDetails({
  values,
  smsRateCards,
  dataRateCards,
  handleNext,
}: {
  values: UserAddValues;
  smsRateCards: { label: string; value: number | string }[];
  dataRateCards: { label: string; value: number | string }[];
  handleNext: () => void;
}) {
  const [passwordShow, setPasswordShow] = useState({
    password: "",
    showPassword: false,
    confirmPassword: "",
    showConfirmPassword: false,
  });

  const handleClickShowPassword = () => {
    setPasswordShow({
      ...passwordShow,
      showPassword: !passwordShow.showPassword,
    });
  };

  const handleClickShowConfirmPassword = () => {
    setPasswordShow({
      ...passwordShow,
      showConfirmPassword: !passwordShow.showConfirmPassword,
    });
  };

  return (
    <MainCard sx={{ mt: 2 }}>
      <Grid container spacing={gridSpacing} justifyContent={"center"} sx={{ mt: "0px" }}>
        <Grid item xs={4}>
          <Grid container>
            <Grid item xs={12}>
              <ItemImageUpload accept=".jpg,.png,.jpeg" label="Upload Profile / Company Image" maxFileSizeInBytes={IMAGE_SIZE} name="profileImage" />
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{ my: 1 }} textAlign="left">
                <Typography variant="caption" fontWeight={"bold"}>
                  User Access
                </Typography>
              </Divider>
              <Grid item xs={12}>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <Tooltip title="fire">
                    <HelpOutlineIcon fontSize="small" color="disabled" />
                  </Tooltip>
                  <SwitchWrapper name="isShowRateCard" label={values.isShowRateCard ? "Show Rate Card" : "Hide Rate Card"} style={{ co: "green" }} />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <Tooltip title="fire">
                    <HelpOutlineIcon fontSize="small" color="disabled" />
                  </Tooltip>
                  <SwitchWrapper
                    name="enableUserCreation"
                    label={values.enableUserCreation ? "Enable User Creation" : "Disable User Creation"}
                    style={{ co: "green" }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <Tooltip title="fire">
                    <HelpOutlineIcon fontSize="small" color="disabled" />
                  </Tooltip>
                  <SwitchWrapper
                    name="enableApiCreation"
                    label={values.enableApiCreation ? "Enable API Campaign" : "Disable API Campaign"}
                    style={{ co: "green" }}
                  />
                </Stack>
              </Grid>
              <Grid item lg={12}>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <Tooltip title="fire">
                    <HelpOutlineIcon fontSize="small" color="disabled" />
                  </Tooltip>
                  <SwitchWrapper
                    name="enableRewardCampaignCreation"
                    label={values.enableRewardCampaignCreation ? "Enable Data Reward Campaign" : "Disable Data Reward Campaign"}
                    style={{ co: "green" }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <Tooltip title="fire">
                    <HelpOutlineIcon fontSize="small" color="disabled" />
                  </Tooltip>
                  <SwitchWrapper
                    name="enableReportDownload"
                    label={values.enableReportDownload ? "Enable Report Download" : "Disable Report Download"}
                    style={{ co: "green" }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  <Tooltip title="fire">
                    <HelpOutlineIcon fontSize="small" color="disabled" />
                  </Tooltip>
                  <SwitchWrapper
                    name="isCampaignNumberHash"
                    label={values.isCampaignNumberHash ? "Hashed Campaign Numbers" : "Show Campaign Numbers"}
                    style={{ co: "green" }}
                  />
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={11} lg={7} md={6} container columnSpacing={1}>
          <Grid item xs={12}>
            <Divider textAlign="left">
              <Typography variant="caption" fontWeight={"bold"}>
                User Details
              </Typography>
            </Divider>
          </Grid>
          {/* <Grid container columnSpacing={gridSpacing}> */}
          <Grid item xs={12} md={8}>
            <TextField required label="Company Name" name="companyName" type="text" />
          </Grid>
          <Grid item xs={12} md={8}>
            <TextField required label="Business Name" name="businessName" type="text" />
          </Grid>
          <Grid item xs={12} sm={6} md={8}>
            <TextField
              required
              label="Company Contact"
              name="companyContact"
              type="tel"
              InputProps={{
                startAdornment: <InputAdornment position="start">+880 |</InputAdornment>,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={8}>
            <TextField
              required
              label="Mobile"
              name="mobile"
              type="tel"
              InputProps={{
                startAdornment: <InputAdornment position="start">+880 |</InputAdornment>,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={8} md={4}>
            <TextField required label="Representative Name" name="representativeName" type="text" />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField required label="Email" name="email" type="email" />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField required label="Company Location" name="companyLocation" type="text" multiline />
          </Grid>
          <Grid item xs={12} sm={6} lg={6} md={4}>
            <Select label="Rate Card *" name="rateCardId" options={smsRateCards} customHandleChange={() => {}} />
          </Grid>
          {values.enableRewardCampaignCreation && (
            <Grid item xs={12} sm={6} lg={6} md={4}>
              <Select label="Data Reward Rate Card *" name="dataRateCardId" options={dataRateCards} customHandleChange={() => {}} />
            </Grid>
          )}
          <Grid item xs={12} sm={6} lg={6} md={4}>
            <Select label="Industry Type *" name="industryType" options={INDUSTRY_TYPES} customHandleChange={() => {}} />
          </Grid>
          <Grid item xs={12} sm={6} lg={6} md={4}>
            <Select label="Account Type *" name="accountType" options={ACCOUNT_TYPES} customHandleChange={() => {}} />
          </Grid>

          <Grid item xs={12} sm={6} lg={6} md={4}>
            <TextField required label="NID Number" name="nid" type="text" />
          </Grid>
          <Grid item xs={12} sm={6} lg={6} md={4}>
            <TextField required label="VAT Number" name="vat" type="text" />
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ mt: 3 }} textAlign="left">
              <Typography variant="caption" fontWeight={"bold"}>
                Login Details
              </Typography>
            </Divider>
          </Grid>
          <Grid item xs={12}>
            <Grid container columnSpacing={gridSpacing}>
              <Grid item lg={8} md={4} sm={12} xs={12}>
                <TextField
                  type={"text"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                  }}
                  name="username"
                  label="Username"
                  placeholder="Username"
                  required
                />
              </Grid>
              {/* <Grid item lg={7} md={7} sm={12} xs={12} /> */}
              <Grid item lg={6} md={4} sm={12} xs={12}>
                <TextField
                  type={passwordShow.showPassword ? "text" : "password"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end">
                          {passwordShow.showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  name="password"
                  label="Password"
                  placeholder="Password"
                  required
                />
              </Grid>
              <Grid item lg={6} md={4} sm={12} xs={12}>
                <TextField
                  type={passwordShow.showConfirmPassword ? "text" : "password"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton aria-label="toggle password visibility" onClick={handleClickShowConfirmPassword} edge="end">
                          {passwordShow.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  name="confirmPassword"
                  label="Confirm Password"
                  placeholder="Confirm Password"
                  required
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={11}>
          <Stack direction={"row"} justifyContent={"flex-end"}>
            <Button onClick={handleNext} endIcon={<ArrowForwardIcon />} variant="contained">
              Next
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </MainCard>
  );
}

export default UserDetails;
